<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes">
                <vs-row>
                    <vs-col sm="12" lg="10">
                        <h4 class="p-2">Escalas de Calificaciones</h4>
                    </vs-col>
                    <vs-col sm="12" lg="2" v-if="JSON.parse(personaRol).roles[0].id == 1">
                        <vs-button
                            success
                            class="ml-auto"
                            @click="activeCrear=!activeCrear"
                        >
                            <i class="fas fa-plus mr-2"></i>Crear registro
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="d-flex">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label class="labelInput" for="nombre">Nombre</label>
                            <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre" />
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label class="labelInput" for="nombre">Tipo</label>
                            <vs-select class="pt-0" placeholder="Tipo" v-model="tipo">
                                <vs-option label="Alfanúmerica" value="1">
                                    Alfanúmerica
                                </vs-option>
                                <vs-option label="Númerica" value="2">
                                    Númerica
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                        <vs-button
                            @click="getEscala()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                 <vs-alert class="my-3" shadow  v-if="mensaje">
                    <template #title>
                        No se encontro información
                    </template>
                </vs-alert>
                <escala :users="info" @refreshTable="getEscala" :personaRol="personaRol"></escala>
                <crear v-model="activeCrear" @refreshTable="getEscala"></crear>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import academico from '../../../../api/requests/academico'
import escala  from './tabla-escala.vue'
import crear from './modales/crear.vue'
export default {
    props: [
        'personaRol'
    ],
    data(){
        return{
            nombre: '',
            tipo: '',
            info: [],
            activeCrear: false,
            mensaje: false
        }
    },
    components:{
        escala,
        crear
    },
    methods:{
        async getEscala(){
            try {
                let params = {
                    "nombre": this.nombre,
                }
                if(this.tipo === '1'){
                    params.tipo = 'alfanumerica'
                } else if(this.tipo === '2'){
                    params.tipo = 'numerica'
                }
                const { data: response } = await academico.getEscala(params)
                this.info = response.data
                if(response == ''){
                    this.mensaje = true
                }else{
                    this.mensaje = false
                }
            }
            catch{
                
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    
    .tache{
        position: absolute;
        cursor: pointer;
        top: 10px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
    
    .labelInput{
        margin-bottom:6px !important;
        padding: 0px 11px 0px 11px;
        font-size: 12px;
    }
</style>